//Semua gambar dari freepik
import Doctor1 from '../../Assets/images/Group 1.svg';
import Doctor2 from '../../Assets/images/Group 3.svg';
import Doctor3 from '../../Assets/images/Group 4.svg';
import Doctor4 from '../../Assets/images/Group 5.svg';
import Doctor5 from '../../Assets/images/Group 6.svg';
import Doctor6 from '../../Assets/images/Group 7.svg';
import Doctor7 from '../../Assets/images/Group 8.svg';
import Doctor8 from '../../Assets/images/Group 9.svg';

export const dataPsychiatrist = [
    {
        img: Doctor1,
        name: "Dr. Agus Utomo Sp.KJ",
        experience: "1 years",
        contact: "+62 86789085432",
        rate: "90%"
    },
    {
        img: Doctor2,
        name: "Dr. Jane Abigail Sp.KJ",
        experience: "5 years",
        contact: "+62 83154763040",
        rate: "98%"
    },
    {
        img: Doctor3,
        name: "Dr. Sezara Athallah Sp.KJ",
        experience: "2 years",
        contact: "+62 81769676836",
        rate: "96%"
    },
    {
        img: Doctor4,
        name: "Dr. Clara Mumtaz Sp.KJ",
        experience: "3 years",
        contact: "+62 82168203099",
        rate: "100%"
    },
]

export const dataPsychologist = [
    {
        img: Doctor5,
        name: "Adhara Eugenia",
        experience: "1 years",
        contact: "+62 86145535467",
        rate: "95%"
    },
    {
        img: Doctor6,
        name: "Jimmie Javier",
        experience: "4 years",
        contact: "+62 83187903702 ",
        rate: "97%"
    },
    {
        img: Doctor7,
        name: "Euanthe Alia",
        experience: "1 years",
        contact: "+62 82185891714",
        rate: "100%"
    },
    {
        img: Doctor8,
        name: "Zoran Rufinus",
        experience: "2 years",
        contact: "+62 80351439806",
        rate: "99%"
    },
]